import React from 'react';
import SafeIcon from '../common/SafeIcon';

export default function CalculatorResults({ calcium, adjustedCa, diff, isSI, albumin }) {
  const unitCa = isSI ? 'mmol/L' : 'mg/dL';
  const normalAlb = isSI ? 40 : 4;
  const factor = isSI ? 0.02 : 0.8;

  return (
    <div className="result-area">
      <div className="result-card">
        <p className="result-label">Valor ajustado estimado</p>
        <div className="result-number">{adjustedCa.toFixed(2)} <small>{unitCa}</small></div>
        <p className="result-summary">Estimativa baseada nos valores informados.</p>
        <div className="result-details">
          <div><span>Cálcio total informado</span><strong>{calcium.toFixed(2)} {unitCa}</strong></div>
          <div><span>Diferença entre os valores</span><strong>{diff > 0 ? '+' : ''}{diff.toFixed(2)} {unitCa}</strong></div>
          <div><span>Albumina informada</span><strong>{albumin.toFixed(1)} {isSI ? 'g/L' : 'g/dL'}</strong></div>
        </div>
        <div className="formula-line">
          Fórmula utilizada: cálcio total + {factor} × ({normalAlb} − albumina)
        </div>
      </div>
      <div className="medical-notice">
        <SafeIcon name="AlertTriangle" className="notice-icon" />
        <p>O cálcio ajustado por albumina é apenas uma estimativa. Fórmulas de correção podem classificar incorretamente o estado do cálcio,especialmente em pacientes hospitalizados ou com alterações importantes. Quando a decisão clínica depende do resultado,considere a medição do cálcio ionizado.</p>
      </div>
    </div>
  );
}
